import { jsx as a, jsxs as D } from "react/jsx-runtime";
import { memo as L, useRef as p } from "react";
import T from "react-cropper";
import { appendAspectRatioToFileName as C } from "../../utils/aspect-ratio.mjs";
import { replaceImageFileBlob as x } from "../../utils/replace-file-blob.mjs";
const U = L(
  ({ imageCropperRef: w, isRounded: d, imageFile: c, imageCropperProps: P }) => {
    const {
      viewMode: R = 1,
      autoCropArea: b = 1,
      aspectRatio: u = 1,
      checkOrientation: I = !1,
      // NOTE: it fixes this issue https://github.com/fengyuanchen/cropperjs/issues/671
      background: E = !0,
      dragMode: N = "move",
      toggleDragModeOnDblclick: M = !1,
      style: f = { height: 400, width: "100%" },
      ...k
    } = P || {}, m = p(null), s = p(null), r = p(null), t = p(null), z = () => {
      s.current && (s.current.style.opacity = ""), r.current && (r.current.style.display = "block"), t.current && (t.current.style.zIndex = "", t.current.innerText = "");
    }, B = () => {
      r.current && t.current && (t.current.appendChild(r.current.cloneNode(!0)), t.current.style.zIndex = "1000", r.current.style.display = "none"), s.current && (s.current.style.opacity = "0");
    }, O = (j) => new Promise((v, h) => {
      var y;
      try {
        const o = (y = m.current) == null ? void 0 : y.cropper;
        if (!o) throw new Error();
        if (d) {
          const n = o == null ? void 0 : o.getCroppedCanvas();
          if (!n) throw new Error();
          const e = Math.min(n.width, n.height), l = document.createElement("canvas");
          l.width = e, l.height = e;
          const i = l.getContext("2d");
          if (!i) throw new Error();
          i.beginPath(), i.arc(e / 2, e / 2, e / 2, 0, Math.PI * 2), i.closePath(), i.clip(), i.drawImage(n, 0, 0, e, e), l.toBlob((g) => {
            if (!c || !g)
              return h(new Error());
            const A = C(
              x(c, g),
              u
            );
            v(A);
          });
        } else
          o.getCroppedCanvas(j).toBlob((n) => {
            if (!c || !n)
              return h(new Error());
            const e = C(
              x(c, n),
              u
            );
            v(e);
          });
      } catch (o) {
        h(o);
      }
    });
    return w && (w.current = {
      hidePreview: z,
      showPreview: B,
      getCroppedFile: O
    }), /* @__PURE__ */ a("div", { children: /* @__PURE__ */ D("div", { className: "relative w-full overflow-hidden", children: [
      /* @__PURE__ */ a(
        "div",
        {
          ref: t,
          className: "absolute inset-0 flex items-center justify-center"
        }
      ),
      /* @__PURE__ */ a(
        "div",
        {
          ref: r,
          style: {
            position: "absolute",
            overflow: "hidden",
            width: f.width,
            height: f.height,
            borderRadius: d ? "50%" : 0
          }
        }
      ),
      /* @__PURE__ */ a("div", { ref: s, children: /* @__PURE__ */ a(
        T,
        {
          className: d ? "sio-cropper-rounded" : "",
          ref: m,
          src: c && URL.createObjectURL(c),
          preview: r || void 0,
          style: f,
          viewMode: R,
          background: E,
          autoCropArea: b,
          aspectRatio: u,
          checkOrientation: I,
          dragMode: N,
          toggleDragModeOnDblclick: M,
          ...k
        }
      ) })
    ] }) });
  }
);
U.displayName = "ImageCropper";
export {
  U as ImageCropper
};
